/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import {firstValueFrom} from 'rxjs';

import {ApiConfig} from '../../app/config/api-config';
import {AdnApiClientService} from '../../app/common/controller/adn-api-client.service';



@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesHelper {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getFromId(id: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['releasenotes', id]),
      params: _.assign({}, {format: 'json', concise: true})
    });
  }

  getFromUrlSlug(urlSlug: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['releasenotes', urlSlug]),
      params: _.assign({}, {format: 'json', concise: true, isUrlSlug: true})
    });
  }

  getPublicFromUrlSlug(urlSlug: string): Promise<any> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['publicreleasenotes', urlSlug]),
      params: _.assign({}, {format: 'json', concise: true})
    });
  }

  queryPublic(apps: string[] | null, since?: number): Promise<any[]> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['publicreleasenotes']),
      params: _.assign({}, {
        format: 'json',
        apps: _.isArray(apps) ? apps : null,
        since: _.isFinite(since) ? moment.unix(since).toDate() : null
      })
    });
  }

  query(apps: string[] | null, includeAll?: boolean, state?: string, since?: number): Promise<any[]> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['releasenotes']),
      params: _.assign({}, {
        format: 'json',
        apps: _.isArray(apps) ? apps : null,
        includeAll: !!includeAll,
        state: state ? state : 'ACTIVE',
        since: _.isFinite(since) ? moment.unix(since).toDate() : null
      })
    });
  }

  post(note: any): Promise<any> {
    return this.send({
      method: 'POST',
      url: this.apiConfig.getVersionedUri(['releasenotes', note.id]),
      body: note
    });
  }

  private send(config: any): Promise<any> {
    return firstValueFrom(this.client.request(config));
  }
}
